import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { UTILS_API_PATH } from "src/confs/APIConfig";
import { useApiGet } from "src/shared/actions/FetchActions";
import type { Country } from "src/shared/objects/Country";

export const useCountries = (
  options?: UseQueryOptions<Country[], unknown, Country[], "countries">,
) => {
  const apiGet = useApiGet();
  return useQuery(
    "countries",
    async () => {
      const { data } = await apiGet<Country[]>(`${UTILS_API_PATH}/countries`);
      return data;
    },
    options,
  );
};
